import request from '../../helpers/requests';
import toast, { Toaster } from 'react-hot-toast';

const ProductsManager = {
    getOptions: async () => {
        return await request.getOptions().then((options) => {
            if(options.success) {
                return options.data;
            }
            else {
                toast.error("There was a critical error retrieving filter options", {position: 'bottom-right'});
            }
        })
    },

    getDefaultFilters: async () => {
        return await request.getDefaultFilters().then((filters) => {
            if(filters.success) {
                return filters.data;
            }
            else {
                toast.error("There was a critical error retrieving default filters", {position: 'bottom-right'});
            }
        })
    },

    getProducts: async (filters = "", page = 1, limit = 10000000, sort = "none", search = "") => {
        return await request.getProducts(filters, page, limit, sort, search).then((products) => {
            if(products.success) {
                return products.data;
            }
            else {
                toast.error("There was a critical error retrieving products", {position: 'bottom-right'});
            }
        })
    },
    getSimilarProducts: async (containerId, count) => {
        return await request.getSimilarProducts(containerId, count).then((products) => {
            if(products.success) {
                return products.data;
            }
            else {
                toast.error("There was a critical error retrieving products", {position: 'bottom-right'});
            }
        })
    },
    getProductsWithCount: async (filters = "", page = 1, limit = 10000000, sort = "none", search = "") => {
        return await request.getProducts(filters, page, limit, sort, search).then((products) => {
            if(products.success) {
                return products.data;
            }
            else {
                toast.error("There was a critical error retrieving products", {position: 'bottom-right'});
            }
        })
    },
}

export default ProductsManager;